var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image is-32x32"},[_c('img',{staticClass:"is-circle",staticStyle:{"width":"32px","height":"32px"},attrs:{"src":_vm.user.profile_picture.sm}})])}
var staticRenderFns = []

export { render, staticRenderFns }